import React from 'react';
import MonitoringLists from '../Containers/MonitoringLists';

function HomePage() {
  return <MonitoringLists />;
}

export default HomePage;
